import type {MemexColumnDataType, SystemColumnId} from '../../../api/columns/contracts/memex-column'
import {BaseColumnModel} from '../abstract/base'

export class LinkedPullRequestsColumnModel extends BaseColumnModel {
  declare readonly id: typeof SystemColumnId.LinkedPullRequests
  declare readonly dataType: typeof MemexColumnDataType.LinkedPullRequests
  declare readonly userDefined: false
}
